import {SmallLoader} from '@kit';

import React, {ReactElement, useRef, useState} from 'react';
import { useApolloClient } from "@apollo/client/react";

import {MonsterDocument} from '../../generated/types';
import {MonsterTooltip} from './types';

import css from './rules-tooltip.module.css';

export const useRulesTooltip = () => {
	const client = useApolloClient();
	const tooltipRef = useRef<HTMLDivElement>(null);
	const [open, setOpen] = useState(false);
	const [loading, setLoading] = useState(true);
	const [data, setData] = useState<any>(null);

	const setAnchor = async (element: HTMLDivElement) => {
		element.style.setProperty('anchor-name', '--rulesTooltip');
		setOpen(true);

		const type = element.dataset.anchorType;
		const id = element.dataset.anchorId;

		setLoading(true);

		// у недоразмеченной ссылки чудовища в базе может не быть: запрос вернёт ошибку и пустые данные
		setData(null);

		if (type === 'monster') {
			const result = await client.query({
				query: MonsterDocument,
				variables: {id},
				errorPolicy: 'all',
			});
			setData(result.data ?? null);
		}

		setLoading(false);
	};

	const unsetSetAnchor = (element: HTMLDivElement | null) => {
		//if (element) element.style.setProperty('anchor-name', null);
		setOpen(false);
	};

	const handleContentMouseOver = (e: React.MouseEvent<HTMLDivElement>) => {
		const target = e.target as HTMLElement;
		const element = target.closest('[data-anchor-type]') as HTMLDivElement | null;
		if (!element) return;

		setAnchor(element);
	};

	const handleContentMouseOut = (e: React.MouseEvent<HTMLDivElement>) => {
		const target = e.target as HTMLElement;
		const element = target.closest('[data-anchor-type]') as HTMLDivElement | null;
		if (!element) return;

		unsetSetAnchor(element);
	};

	const RulesTooltip = (): ReactElement | null =>
		open || true ? (
			<div ref={tooltipRef} className={css.tooltip}>
				{loading ? <SmallLoader /> : data?.monster ? <MonsterTooltip monster={data.monster} /> : null}
			</div>
		) : null;

	return {
		handleContentMouseOver,
		handleContentMouseOut,
		RulesTooltip,
	};
};
